/**
 * @generated SignedSource<<c8d0cac318f9944f76bbfc65b46471ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Folder_viewer$data = {
  readonly favoritesPageRedesignFF: boolean | null;
  readonly " $fragmentType": "Folder_viewer";
};
export type Folder_viewer$key = {
  readonly " $data"?: Folder_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Folder_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Folder_viewer",
  "selections": [
    {
      "alias": "favoritesPageRedesignFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "favoritesPageRedesign"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"favoritesPageRedesign\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f05bb356a220c124f3c0a13456e50ac7";

export default node;
